<template>
  <div class="profile-menu">
    <span class="f-1">{{ $store.getters['auth/getUserFullName'] }} | </span>
    <AppLogout />
  </div>
</template>

<script>
import AppLogout from '@/components/widgets/menu/AppLogout';

export default {
    name: 'AccountMenu',
    components: {
        AppLogout
    }
};
</script>

<style scoped></style>
